import { Collapsible } from '@gurupay/gp-ui-library';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { InfoRow } from './InfoRow';

export const RoleSection: FC<{
	title: string;
	email?: string;
	phone?: string;
	isLoading: boolean;
}> = ({ title, email, phone, isLoading }) => {
	const { t } = useTranslation('', { keyPrefix: 'profile' });

	return (
		<Collapsible
			className="border-x-1 rounded-md px-space-16 py-space-8"
			iconPosition="right"
			title={title}
		>
			<dl className="flex flex-col gap-space-16">
				<InfoRow isLoading={isLoading} label={t('email')} value={email} />
				<InfoRow isLoading={isLoading} label={t('phone')} value={phone} />
			</dl>
		</Collapsible>
	);
};
